export const platforms = [
  {
    id: 'ultrapass',
    name: 'UltraPass',
    logo: 'https://readdy.ai/api/search-image?query=UltraPass%20premium%20platform%20logo%20design%20dark%20background%20gold%20accents%20luxurious%20minimalist%20geometric%20shape%20sophisticated%20brand%20identity%20clean%20modern%20aesthetic&width=200&height=200&seq=ultrapass-logo&orientation=squarish',
    rating: 9.2,
    category: 'hd',
    tags: ['4K超清', '海量片库', '每日更新', '正版授权'],
    description: 'UltraPass 是目前欧美无码领域最全面的高清平台，拥有超过50万部正版授权内容，支持4K超清画质和杜比音效，每日更新超过200部新片。平台界面简洁直观，支持多设备同步观看。',
    features: ['4K/8K超清画质', '杜比全景声', '离线下载', '多设备同步', 'AI智能推荐', '无广告体验'],
    price: '$29.99/月',
    contentCount: '500,000+',
    updateFrequency: '每日200+',
    pros: ['画质业界顶尖', '片库极为丰富', '更新频率高', '多语言字幕'],
    cons: ['价格偏高', '部分地区需VPN'],
    url: '#',
    color: '#D4A574',
  },
  {
    id: 'crystalstream',
    name: 'CrystalStream',
    logo: 'https://readdy.ai/api/search-image?query=CrystalStream%20premium%20VR%20platform%20logo%20dark%20background%20crystal%20blue%20transparent%20geometric%20design%20modern%20clean%20luxurious%20sophisticated&width=200&height=200&seq=crystalstream-logo&orientation=squarish',
    rating: 9.0,
    category: 'vr',
    tags: ['VR沉浸', '8K全景', '互动体验', '独家内容'],
    description: 'CrystalStream 专注于VR沉浸式成人内容体验，提供8K全景视频和互动式内容。平台拥有独家VR制作团队，内容质量在业内遥遥领先，支持主流VR设备。',
    features: ['8K VR全景', '互动式剧情', 'Oculus/Quest支持', '空间音频', '实时渲染', '社交VR体验'],
    price: '$34.99/月',
    contentCount: '80,000+',
    updateFrequency: '每周500+',
    pros: ['VR体验最佳', '独家原创内容', '设备兼容性好', '沉浸感强'],
    cons: ['需要VR设备', '内容库相对较小'],
    url: '#',
    color: '#7EB8DA',
  },
  {
    id: 'primeflix',
    name: 'PrimeFlix',
    logo: 'https://readdy.ai/api/search-image?query=PrimeFlix%20premium%20streaming%20platform%20logo%20dark%20background%20crimson%20red%20accents%20minimalist%20geometric%20luxurious%20modern%20brand&width=200&height=200&seq=primeflix-logo&orientation=squarish',
    rating: 8.8,
    category: 'hd',
    tags: ['独家原创', '4K画质', '多设备', '家庭共享'],
    description: 'PrimeFlix 以独家原创内容著称，与全球顶级制作团队合作，产出高品质原创欧美无码内容。平台支持多达5个设备同时使用，性价比极高。',
    features: ['独家原创系列', '4K HDR', '5设备共享', '家长控制', '个性化推荐', '杜比视界'],
    price: '$24.99/月',
    contentCount: '200,000+',
    updateFrequency: '每日100+',
    pros: ['独家内容优质', '家庭共享实惠', '界面友好', '多设备支持'],
    cons: ['独家内容占比高', '部分经典内容缺失'],
    url: '#',
    color: '#C44D4D',
  },
  {
    id: 'novaview',
    name: 'NovaView',
    logo: 'https://readdy.ai/api/search-image?query=NovaView%20live%20streaming%20platform%20logo%20dark%20background%20purple%20magenta%20gradient%20modern%20clean%20geometric%20luxurious%20sophisticated&width=200&height=200&seq=novaview-logo&orientation=squarish',
    rating: 8.5,
    category: 'live',
    tags: ['直播互动', '实时聊天', '打赏系统', '全球主播'],
    description: 'NovaView 是领先的欧美无码直播互动平台，汇聚全球优质主播，提供实时互动体验。支持高清直播、虚拟礼物打赏和一对一私密聊天功能。',
    features: ['1080P高清直播', '实时互动聊天', '虚拟礼物', '私密房间', '主播预约', '回放功能'],
    price: '$19.99/月（基础）',
    contentCount: '10,000+主播',
    updateFrequency: '24/7直播',
    pros: ['实时互动体验', '全球主播资源', '社交功能丰富', '价格灵活'],
    cons: ['内容质量不稳定', '依赖主播在线'],
    url: '#',
    color: '#9B59B6',
  },
  {
    id: 'elitehub',
    name: 'EliteHub',
    logo: 'https://readdy.ai/api/search-image?query=EliteHub%20classic%20vintage%20platform%20logo%20dark%20background%20copper%20bronze%20accents%20retro%20elegant%20sophisticated%20minimalist%20geometric&width=200&height=200&seq=elitehub-logo&orientation=squarish',
    rating: 8.3,
    category: 'classic',
    tags: ['经典影片', '复古风格', '修复画质', '珍藏系列'],
    description: 'EliteHub 专注于经典欧美无码影片的数字化修复与珍藏，收录了从70年代至今的经典作品，通过AI修复技术还原高清画质，是怀旧爱好者的首选平台。',
    features: ['AI画质修复', '经典珍藏系列', '年代分类', '影人档案', '幕后花絮', '收藏夹'],
    price: '$14.99/月',
    contentCount: '100,000+',
    updateFrequency: '每周300+',
    pros: ['经典内容独家', '画质修复出色', '影人资料丰富', '价格实惠'],
    cons: ['新片更新慢', '画风偏复古'],
    url: '#',
    color: '#B87333',
  },
  {
    id: 'purevision',
    name: 'PureVision',
    logo: 'https://readdy.ai/api/search-image?query=PureVision%20mobile%20optimized%20platform%20logo%20dark%20background%20emerald%20green%20accents%20modern%20clean%20minimalist%20sophisticated&width=200&height=200&seq=purevision-logo&orientation=squarish',
    rating: 8.7,
    category: 'mobile',
    tags: ['移动优化', '离线下载', '数据节省', '流畅体验'],
    description: 'PureVision 是专为移动端优化的欧美无码平台，提供极致流畅的移动观影体验。支持智能流量节省、离线下载和夜间模式，是手机用户的理想选择。',
    features: ['移动端专属优化', '智能省流模式', '离线下载', '夜间模式', '竖屏适配', '后台播放'],
    price: '$12.99/月',
    contentCount: '300,000+',
    updateFrequency: '每日150+',
    pros: ['移动体验极佳', '价格亲民', '省流量', '下载速度快'],
    cons: ['PC端体验一般', '画质上限1080P'],
    url: '#',
    color: '#27AE60',
  },
  {
    id: 'luxeplay',
    name: 'LuxePlay',
    logo: 'https://readdy.ai/api/search-image?query=LuxePlay%20AI%20powered%20platform%20logo%20dark%20background%20platinum%20silver%20accents%20futuristic%20minimalist%20geometric%20luxurious%20sophisticated&width=200&height=200&seq=luxeplay-logo&orientation=squarish',
    rating: 9.1,
    category: 'hd',
    tags: ['AI推荐', '个性化', '智能标签', '学习偏好'],
    description: 'LuxePlay 运用先进的AI技术，为用户提供极度个性化的内容推荐。平台通过学习用户的观看偏好，智能匹配最合适的内容，让每次访问都有新发现。',
    features: ['AI深度学习推荐', '智能标签系统', '个性化首页', '偏好学习', '相似内容发现', '观看历史分析'],
    price: '$27.99/月',
    contentCount: '400,000+',
    updateFrequency: '每日180+',
    pros: ['推荐精准', '发现新内容容易', '界面个性化', '学习速度快'],
    cons: ['新用户需时间训练', '隐私关注'],
    url: '#',
    color: '#C0C0C0',
  },
  {
    id: 'stargate',
    name: 'StarGate',
    logo: 'https://readdy.ai/api/search-image?query=StarGate%20global%20platform%20logo%20dark%20background%20midnight%20blue%20star%20motif%20minimalist%20geometric%20luxurious%20elegant%20sophisticated&width=200&height=200&seq=stargate-logo&orientation=squarish',
    rating: 8.6,
    category: 'hd',
    tags: ['全球内容', '多语言', '跨区域', '本地化'],
    description: 'StarGate 是全球化的欧美无码内容平台，汇聚世界各地优质内容，支持15种语言界面和字幕。平台在全球多个区域设有CDN节点，确保流畅观看体验。',
    features: ['15种语言支持', '全球CDN加速', '区域内容定制', '多币种支付', '本地化推荐', '跨设备同步'],
    price: '$22.99/月',
    contentCount: '350,000+',
    updateFrequency: '每日160+',
    pros: ['全球访问流畅', '多语言友好', '内容多样化', '支付方式丰富'],
    cons: ['部分区域限制', '界面略显复杂'],
    url: '#',
    color: '#2C3E80',
  },
];

export const platformRatings: Record<string, {
  contentQuality: number;
  userExperience: number;
  valueForMoney: number;
  updateSpeed: number;
  safety: number;
}> = {
  ultrapass: { contentQuality: 9.5, userExperience: 9.0, valueForMoney: 8.5, updateSpeed: 9.5, safety: 9.5 },
  crystalstream: { contentQuality: 9.0, userExperience: 8.5, valueForMoney: 8.0, updateSpeed: 8.5, safety: 9.0 },
  primeflix: { contentQuality: 8.5, userExperience: 9.0, valueForMoney: 9.0, updateSpeed: 8.0, safety: 9.0 },
  novaview: { contentQuality: 7.5, userExperience: 8.5, valueForMoney: 9.0, updateSpeed: 9.5, safety: 8.0 },
  elitehub: { contentQuality: 8.0, userExperience: 8.0, valueForMoney: 9.0, updateSpeed: 7.0, safety: 9.0 },
  purevision: { contentQuality: 8.0, userExperience: 9.0, valueForMoney: 9.5, updateSpeed: 8.5, safety: 9.0 },
  luxeplay: { contentQuality: 9.0, userExperience: 9.5, valueForMoney: 8.5, updateSpeed: 9.0, safety: 9.0 },
  stargate: { contentQuality: 8.5, userExperience: 8.0, valueForMoney: 8.5, updateSpeed: 8.5, safety: 9.5 },
};